import { Spinner } from '@george-labs.com/design-system';

import { createLazyComponent } from '@luna/utils-ui';

export const LazyHandoffExchange = createLazyComponent(
    () => import('../HandoffExchange').then(({ HandoffExchange }) => HandoffExchange),
    {
        fallback: <Spinner size={Spinner.SIZE.LARGE} center className="mt-5" />,
    },
);
